import { render, staticRenderFns } from "./PersonnelMessage.vue?vue&type=template&id=e2b5c076"
import script from "./PersonnelMessage.vue?vue&type=script&lang=js"
export * from "./PersonnelMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports